import React, { useState, useEffect } from "react";
import JoinTableModal from "../JoinTableModal";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const navigate = useNavigate();

  const handleClick = () => {
    window.open(
      "https://resy.com/cities/edison-nj/venues/house-of-bombay",
      "_blank",
      "noopener,noreferrer"
    );
  };
  useEffect(() => {
    const submitted = localStorage.getItem("hob-member");

    if (location.pathname === "/" && !submitted) {
      setShowModal(true);
    }
  }, [location.pathname]);
  return (
    <>
      {/* Offer Strip */}
      <div className="offer-strip">
        <span className="offer-text">LET’S HOB IT NOW!</span>
      </div>
      <section className="header-section">
        <div className="header-container">
          {/* Left Section */}
          <div className="header-left">
            {/* Logo */}
            <div className="logo">
              <a href="/">
                <img src="/hob_logo.png" alt="House of Bombay" />
              </a>
            </div>

            {/* Menu below logo */}
            <nav className="nav-menu">
              <a href="/">HOME</a>
              <a href="/about-us">ABOUT US</a>
              <a href="/our-menu">OUR MENU</a>
              <a href="/reservations">RESERVATIONS</a>
              <a href="/careers">CAREERS</a>
            </nav>
          </div>

          {/* Join Button */}
          <div className="header-buttons">
            <button className="member-btn" onClick={() => setShowModal(true)}>
              BE A MEMBER
            </button>

            <button className="join-table-btn" onClick={handleClick}>
              JOIN THE TABLE
            </button>
          </div>

          {/* Hamburger */}
          <div
            className={`hamburger ${menuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>
          <div className="menu-border-left"></div>
          <div className="menu-border-right"></div>
          <div className="menu-border-top">
            <button className="menu-close" onClick={toggleMenu}>
              ✕
            </button>
          </div>
          <div className="menu-par">
            <nav>
              <a href="/">HOME</a>
              <a href="/about-us">ABOUT US</a>
              <a href="/our-menu">OUR MENU</a>
              <a href="/reservations">RESERVATIONS</a>

              <a href="/careers">CAREERS</a>
            </nav>

            <button className="mobile-join-btn" onClick={handleClick}>
              JOIN THE TABLE
            </button>

            <button
              className="mobile-member-btn"
              onClick={() => setShowModal(true)}
            >
              BE A MEMBER
            </button>
          </div>
          <div className="mobile-logo">
            <img src="/menu_logo.png" alt="House of Bombay" />
          </div>
        </div>
        <JoinTableModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      </section>
    </>
  );
};

export default Header;
